import FavouritesUnlocked from './FavouritesUnlocked';
import { connect } from '../../node_modules/react-redux';
import { setOnboardingStep } from '../../state/actions/currentOnboarding';
var mapDispatchToProps = {
  setOnboardingStep: setOnboardingStep
};
export default connect(null, mapDispatchToProps)(FavouritesUnlocked);